import React, { useEffect } from "react";

const PaymentSuccess = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "https://stage.aichanakya.in";
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      backgroundColor: "#f0f8ff",
      fontFamily: "Arial, sans-serif",
    },
    heading: {
      color: "#4CAF50",
      fontSize: "2.5rem",
      marginBottom: "20px",
    },
    message: {
      fontSize: "1.2rem",
      textAlign: "center",
      maxWidth: "80%",
      lineHeight: "1.5",
    },
    redirect: {
      marginTop: "20px",
      color: "#666",
      fontSize: "1rem",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Payment Successful!</h1>
      <p style={styles.message}>
        Thank you for your purchase. Your transaction has been completed.
      </p>
      <p style={styles.redirect}>Redirecting you in 2 seconds...</p>
    </div>
  );
};

export default PaymentSuccess;
